import './App.css';
import { useState, useEffect, useRef} from 'react';
import io from 'socket.io-client'

const socket = io.connect("https://tycoon-api.onrender.com") //the thing where we connect to back end
//const socket = io.connect("http://localhost:3001")
//const SUITS = ["S", "C", "D", "H"]
const VALUES = ['3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A', '2']
const REVVALUES = ['2', 'A', 'K', 'Q', 'J', '10', '9', '8', '7', '6', '5', '4', '3']

function card_order(i, rev){
  var value
  if (i === "JB" || i === "JR"){
    value = 20
    return value
  }
  if (rev === true){
    value = REVVALUES.indexOf(i.slice(1))
  }
  else{
    value = VALUES.indexOf(i.slice(1))
  }
  return value
}

function sort_deck(deck){
  var temp;
  var swapped;
  for (let i = 0; i < deck.length; i++) //for every card in deck, errr this doesn't account suits
  {
    swapped = false;
    for (let j = 0; j < deck.length - i - 1; j++) 
    {
      if (card_order(deck[j], false) > card_order(deck[j + 1], false)) 
      {
          // Swap arr[j] and arr[j+1]
          temp = deck[j];
          deck[j] = deck[j + 1];
          deck[j + 1] = temp;
          swapped = true;
      }
    }
    if (swapped === false){
      break
    }
  }
  return deck
}

/////
function HistoryLog({historylog}){ //the history log, scroll to bottom

  const logmessage = (historylog) => {

    function check_joker(){
      if(historylog['card'].length >= 2 && card_order(historylog['card'][(historylog['card'].length-1)]) === 20 && card_order(historylog['card'][(historylog['card'].length-2)]) === 20){
        return 2
      }
      else if (historylog['card'].length >= 1 && card_order(historylog['card'][(historylog['card'].length-1)]) === 20){
        return 1
      }
      else{
        return 0
      }
    }

    function num_to_word(num){
      if (num === 1){
        return "a" //could be one
      }
      else if(num === 2){
        return "two"
      }
      else if(num === 3){
        return "three"
      }
      else{
        return "four"
      }
    }/////

    let cardnumber = historylog['card'][0]
    let special = historylog['special']
    const cardslength = historylog['card'].length
    const cardslengthword = num_to_word(cardslength)
    const player = historylog['player'] === "playerturnhist" ? "You " : "Opponent " 

    if (cardnumber === 'winner'){ //winner
      return player + " won!"
    }
    else if (special === 'passed'){ //passed
      if (cardnumber === 'S3'){
        return player + " played a 3 of Spades against a Joker! It's " + (player === 'You '? "your" : "the opponent's") + " turn again!"
      }
      else{
        return player + " passed"
      }
    }
    else if (special === 'revolution'){
      return player + " caused a Revolution!"
    }
    else if (special === 'counterrevolution'){
      return player + " caused a Counter Revolution!"
    }
    else{
      if (cardnumber === "JR" || cardnumber === "JB"){
        cardnumber = 'Joker'
      }
      else{
        cardnumber = cardnumber.slice(1)
      }
      const numofjokers = check_joker()
      if (cardnumber === '8' && numofjokers === 0){
        return player + "played " + cardslengthword + " " + cardnumber + (cardslength > 1 ? 's' : "") 
        + ", it's " + (player === 'You '? "your" : "the opponent's") + " turn again!" 
      }
      else if (cardnumber === '8' && numofjokers !== 0){
        return player + "played " + num_to_word(cardslength - numofjokers) + " " + cardnumber 
        + ((cardslength - numofjokers) > 1 ? 's' : "") + " and " 
        + num_to_word(numofjokers) + " Joker"+ (numofjokers > 1 ? 's' : "")
        + ", it's " + (player === 'You '? "your" : "the opponent's") + " turn again!"
      }
      else{ //no 8s
        if(numofjokers === cardslength){ //only jokers were played
          return player + "played " + num_to_word(cardslength) + " " + cardnumber 
          + (cardslength > 1 ? 's' : "")
        }
        else if(numofjokers !== 0){ //has one or 2 jokers but not same length
          return player + "played " + num_to_word(cardslength - numofjokers) + " " + cardnumber 
          + ((cardslength - numofjokers) > 1 ? 's' : "") + " and " 
          + num_to_word(numofjokers) + " Joker"+ (numofjokers > 1 ? 's' : "")
        }
      }
    }//none of the above
    return player + "played " + cardslengthword + " " + cardnumber + (cardslength > 1 ? 's' : "")
  }

  const histlog = useRef(null) //ohhhhh this is like, a dom!!!!!
  let history = []

  for (let i = 0; i < historylog.length; i++){ //[0] is the person who played, [1] is the cards
    const histstring = logmessage(historylog[i])
    history.push(<p key = {i} className={historylog[i]['player']}> {histstring} </p>)
  }
  useEffect(() => { //damn use effect and ref
    if (history.length !== 0){ //uh no history, so no dom, change to scroll heighttt
      histlog.current.scrollTop = histlog.current.scrollHeight
    }
  })
  return(
    <div ref = {histlog} id ="historybox">
      {history}
    </div>
  )
}

function Card({current, card, deck, onCardClick, cardcolors}){
  const imagename = deck[card].slice(0, 1) + '-' + deck[card].slice(1) + ".png"
  if (current[card]){ //is a current card, clickable
    return <img src={require('./images/' + imagename)} className={'player cardselected'} onClick={onCardClick} alt= {deck[card]}/>
  }
  else if(cardcolors[card] === 'grey'){ //grey card, not clickable
    return <img src={require('./images/' + imagename)} className={'player cardgrey'} alt= {deck[card]}/>
  }
  else{ //light card, clickable
    return <img src={require('./images/' + imagename)} className={'player card'} onClick={onCardClick} alt= {deck[card]}/>
  }
}

function JoinPanel({setRoom, joinRoom}){
  return(
    <>
      <div id='greypanel'>
        <input id = 'joininput'
          placeholder='Room Code...' 
          onChange={(event) =>{
          setRoom(event.target.value)
        }}></input>
        <br></br>
        <button onClick={joinRoom}> Join Room</button>
      </div>
    </>
  )
}

function PlayedCard({card, deck}){
  const imagename = deck[card].slice(0, 1) + '-' + deck[card].slice(1) + ".png"
  return <img src={require('./images/' + imagename)} className={'static card'} alt = {deck[card]}/>
}

function OpponentArea({decknum}){
  let componentArr = [] //render cards
  const deck = Array(13).fill('BC')
  for (let i = 0; i < decknum; i++) {
    componentArr.push(
      <PlayedCard key={i} 
      deck = {deck} 
      card = {i}/>);
  }
  return (
    <>
      <div className = {'opponent hand'}>
        {componentArr}
      </div>
    </>
  )
}

function PlayArea({playcards}){
  let playareadiv = []
  for (let i = 0; i < playcards.length; i++) {
    playareadiv.push(<PlayedCard key={i} deck = {playcards} card = {i}/>);
  }

  return (
    <>
      <div id= 'playarea'>
        {playareadiv}
      </div>
    </>
  )
}

//////////////

function CardArea({Hand, setHand, Turn, PlayAreaCards, Onplayclick, OnRevolution, Rev, Disable, Restart, Quit, currentcards, setcurrentcards, currentcardnum, setcurrentcardnum}){

  function playcards(){ //when playing selected cards
    // if (!Turn || Disable){
    //   return
    // }
    if (currentcardnum === 0){ //if no slected cards
      return;//go back
    }

    var clearboard = false

    //special rules
    const nexthand = []
    for (let j = 0; j < currentcards.length; j++){
      if (currentcards[j]){ //selected card
        if (currentcards[j].slice(1) === '8' || (currentcards[j] === 'S3' && PlayAreaCards.length === 1 && card_order(PlayAreaCards[0]) === 20)){ //8 stop or 3 of spades on one 
          clearboard = true
        }
      }
      else
      {
        nexthand.push(Hand[j]) //add the unselected cards to next hand
      }
    }

    setHand(nexthand) //setnext hand to delyeet current cards
    //setHandnum(Handnum-currentcardnum)
    if (clearboard === true){ //8 stop or 3 of spades
      if (currentcardnum === 4){ //revolutionnnnn (and four 8s)
        OnRevolution(!Rev)
        Onplayclick(currentcards, Hand.length-currentcardnum, true, !Rev)
      }
      Onplayclick(currentcards, Hand.length-currentcardnum, true, Rev)
    }
    else{
      if (currentcardnum === 4){ //revolutionnnnn
        OnRevolution(!Rev)
        Onplayclick(currentcards, Hand.length-currentcardnum, false, !Rev)
      }
      else{
        Onplayclick(currentcards, Hand.length-currentcardnum, false, Rev) //play these current cards to the play area
      }
    }
    setcurrentcards(Array(Hand.length-currentcardnum).fill(null)) //reset current cards
    setcurrentcardnum(0)
  }

  function selectcard(i){ //when selecting cards
    if (!Turn){ //not your turn
      return
    }
    const nextcards = currentcards.slice() //get current cards in hand
    if (nextcards[i]){ //if that card was already selected (red), deselect
      nextcards[i] = null
      setcurrentcards(nextcards)
      setcurrentcardnum(currentcardnum - 1)
      return
    }
    if (currentcardnum === 4){ //can only hold a max of 4 cards
      return //do nothing
    }

    //add card to deck, is not red card
    nextcards[i] = (Hand[i]) 
    setcurrentcards(nextcards)
    setcurrentcardnum(currentcardnum + 1)
    return
  }

  function pass(){
    if (!Turn || Disable){ 
      return
    }
    setcurrentcards(Array(Hand.length).fill(null)) //reset current cards
    setcurrentcardnum(0)
    Onplayclick([], Hand.length, false, Rev)
  }

  function calc_what_playablecards() //calculates what cards are playable based on playable cards, maybe rewrite bc idk how this works lmao
  {
    function card_logic(rev){ //calculate card values

      const cardcolors = [] //empty array
      var numofcards = 1 //number of cards same number
      var extrajoker = 0 //any jokers we hold
      if (Hand.length > 1 && card_order(Hand[Hand.length-1]) === 20){ //if there is ONE joker in the end
        extrajoker++
        if(Hand.length > 2 && card_order(Hand[Hand.length-2]) === 20){ //there are TWO jokers in the end(replace with slice?)
          extrajoker++
        }
      }
      for (var i = 0; i < Hand.length; i++)
      {
        if (card_order(Hand[i], rev) <= card_order(PlayAreaCards[0], rev)){ //if the card in hand is less than played area card, make grey
          cardcolors.push('grey')
        }
        else{ //playable card but we gotta check number of cards
          if (PlayAreaCards.length === 1){ //only one card in play, so just push, includes joker
            cardcolors.push('playable')
          }
          else if(PlayAreaCards.length > Hand.length){ //this is for playlength > 1, if played area cards lenght is greater than hand
            cardcolors.push('grey')
          }
          else if(Hand[i+1] && card_order(Hand[i+1], rev) === card_order(Hand[i], rev)){ //not last array, check next card, if match
            numofcards++
          }
          else if(Hand[i+1] && card_order(Hand[i+1], rev) !== card_order(Hand[i], rev)){ //not last array, check next card, if NOT match
            for (var j = 0; j < numofcards; j++){
              if (numofcards + extrajoker >= PlayAreaCards.length){
                cardcolors.push('playable')
              }
              else{
                cardcolors.push('grey')
              }
            }
            numofcards = 1 //restart num of cards
          }
          else{ //last array index, its card number playable but check num of cards
            for (var h = 0; h < numofcards; h++){
              if (extrajoker > 0){ //last index is a joker card (or 2 jokers)
                if(cardcolors.includes("playable")){ //if playable cards in array, meaning joker can subsitute for double/triple/4s
                  cardcolors.push('playable')
                }
                else{ //if there are any NO playable cards previously
                  //if there are double jokers that can only beat the playable area or one joker can playarea 1
                  if((extrajoker === 2 && PlayAreaCards.length === 2) || (extrajoker === 1 && PlayAreaCards.length === 1)){
                    cardcolors.push('playable')
                  }
                  else{ //none of the above
                    cardcolors.push('grey')
                  }
                }
              }
              else{ //no jokers
                if (numofcards >= PlayAreaCards.length){
                  cardcolors.push('playable')
                }
                else{
                  cardcolors.push('grey')
                }
              }
            }
          }
        }
      }
      return cardcolors
    }

    const cardcolors = []

    if (PlayAreaCards.length === 0 && currentcardnum === 0) //no cards played (and no held cards), everything is playable
    {
      return Array(Hand.length).fill('playable')
    }

    if (PlayAreaCards.length === 1 && card_order(PlayAreaCards[0]) === 20) //3 of spades exception for single joker
    {
      for (var l of Hand){
        if (l === "S3"){//three of spades card
          cardcolors.push('playable')
        }
        else{
          cardcolors.push('grey')
        }
      }
      return cardcolors
    }

    if (PlayAreaCards.length === currentcardnum || currentcardnum === 4) ///same of playable card number as current or four cards, so just grey everything except current cards
    {
      for (var i of currentcards){ //current card, not null
        if (i){
          cardcolors.push('playable')
        }
        else{ //null card
          cardcolors.push('grey')
        }
      }
      return cardcolors
    }

    if (currentcardnum === 0){
      if (Rev === false){
        return card_logic(false)
      }
      else{ //revolution, so reverse values
        return card_logic(true)
      }
    }
    else{ //has at least ONE card held
      for (var h of currentcards){
        if(h){//first not null card
          if (card_order(h) === 20){ //joker card held (or last one was joker card)
            if (Rev === false && PlayAreaCards.length !== 0){ //Jokers can subsitute for cards so use card logic, doesn't work if playarea is empty
              return card_logic(false)
            }
            else if(Rev === true && PlayAreaCards.length !== 0){ //revolution, so reverse values, same as above
              return card_logic(true)
            }
            else{//joker was picked first but also playarea is empty
              return Array(Hand.length).fill('playable')
            }
          }
          else{ //not joker card (or its the last one)
            for (var n of Hand)
            {
              if (card_order(n) === 20) //jokers are all playable with the other
              {
                cardcolors.push('playable')
              }
              else if (card_order(n) === card_order(h)){ //playable same card
                cardcolors.push('playable')
              }
              else{ //not joker or same num card
                cardcolors.push('grey')
              }
            }
            return cardcolors
          }
        }
      }
      throw new Error("We have no current cards"); ///uh shouldnt be here
    }
  }

  /////also rewrite selected card to only pick non grey card and played card to just fucking play the cards


  let componentArr = [] //render cards
  const cardcolors = (Turn && !Disable) ? calc_what_playablecards() : Array(Hand.length).fill('grey') //if your turn and not disabled, calc all cards colors
  //console.log(cardcolors)
  for (let i = 0; i < Hand.length; i++) {
    componentArr.push(
      <Card key={i} 
      cardcolors = {cardcolors}
      onCardClick={() => selectcard(i)} 
      current = {currentcards} 
      deck = {Hand} 
      card = {i}/>);
  }

  return(
    <>
      <div className = {'player hand'}>
        {componentArr}
      </div>
      <div id='greypanel2'>
        {Disable ? 
          <>
            <button onClick={Restart}>Next Round</button>
            <button style={{'marginLeft': '16px'}} onClick={Quit}>Quit Game</button> 
          </>
          :
          <>
            <button onClick={() => playcards()}>Play Card</button>
            <button style={{'marginLeft': '70px'}} onClick={() => pass()}>Pass</button> 
          </>
        }
      </div>
  </>
  )
}

function Board(){
  const [room, setRoom] = useState("") //room number
  const [playareacards,setplayarea] = useState([]) //the play area cards
  const [revolution, setrevolution] = useState(false)
  const [winner, setWinner] = useState(false)
  const [inroom, setRoombool] = useState(false) //if in a room, the whole card game room
  const [yourturn, setyourturn] = useState(false)
  const [opponentnum, setopponentnum] = useState(13)
  const [hand, setHand] = useState([]) //your hand is empty at the start
  const [inwaitroom, setwaitroom] = useState(false)
  const [historylog, setHistorylog] = useState([])
  const [currentcards, setcurrentcards] = useState([]) //set current cards to save, ugh why did i rewrite this?
  const [currentcardnum, setcurrentcardnum] = useState(0) //current number of cards we have that are selected

  useEffect(() => { //calls when the component renders/added, or socket is updated?
    socket.on('is1st', (deck) => { //player goes first
      setRoombool(true)
      setHand(sort_deck(deck))
      setcurrentcards(Array(deck.length).fill(null))
      setyourturn(true)
      //setwaitroom(true)
    })

    socket.on('is2nd', (deck) => { //player who get 2nd
      setRoombool(true)
      setHand(sort_deck(deck))
      setcurrentcards(Array(deck.length).fill(null))
    })

    socket.on('setwaitroom', () => { //set wait room
      setRoombool(true) //in a room
      setwaitroom(true) //set wait room
    })

    socket.on('player2joined', () => { //other player joined
      setwaitroom(false) //quit room
    })

    socket.on('update_game', (newopponentnum, playedcards, skip, rev) => { //your opponent played their cards
      if (!skip){ //not skip
        setyourturn(!yourturn)
        setplayarea(playedcards)
      }
      else{ //skip
        setplayarea([])
      }
      setrevolution(rev)
      setopponentnum(newopponentnum)
      gethistorylog(playedcards) //set history log
      if (newopponentnum === 0){
        setWinner(true)
        gethistorylog(['winner']) //set history log
      }
    })

    socket.on('new_round', (deck, isyourturn) => { //other player joined
      newgame()
      setHand(sort_deck(deck))
      setyourturn(isyourturn)
      setcurrentcards(Array(deck.length).fill(null))
    })


    socket.on('reset_game_state', () => { //reset game state (on disconnect from other player)
      newgame()
    })

    return() => {
      socket.off('is1st')
      socket.off('is2nd')
      socket.off('setwaitroom')
      socket.off('player2joined')
      socket.off('update_game')
      socket.off('new_round')
      socket.off('reset_game_state')
    }
  })

  useEffect(() => { //alerts in case the below happens
    socket.on('disconnected', (reason) => {
      setRoombool(false)
      setwaitroom(false)
      if (reason === false){ //other person disconnected by closing tab
        alert("The opponent disconnected!")
      }
      else{ //other person quit the game
        alert("The opponent quit the game")
      }
    })

    socket.on('deny', () => {
      alert('Room not avaliable')
    })
    return () => { 
      socket.off('deny') //um rename this if i split up files
      socket.off('disconnected')
    }
  },[]) //<- add this empty list so it fires only once

  function onplaycards(playedcards, handnumber, skip, rev){ //you played your cards, get number of cards after playing, if you skip or have rev
    if (winner === true){
      return //win, so no point in playing
    }
    let temp = [] //cards played, get rid of null
    for (let i of playedcards){
      if (i){
        temp.push(i)
      }
    }
    socket.emit("play_cards", room, handnumber, temp, skip, rev)
    if (!skip){ //didn't skip a turn
      setyourturn(!yourturn) //switch turns
      gethistorylog(temp) //set history log
    } 
    else { //8 stop or 3 of spades, or pass
      gethistorylog(temp, true) //set history log
      temp = []
    }
    setplayarea(temp)
    if (handnumber === 0){
      setWinner(true)
      gethistorylog(['winner']) //set history log to have winner
    }
  }

  function newgame(){ //for reset game state on user end (no deck yet)
    setyourturn(false)
    setrevolution(false)
    setplayarea([])
    setopponentnum(13)
    setWinner(false)
    setHistorylog([])
  }

  function quitgame(){
    socket.emit("quitgame", room)
    setRoom("") //no room number now
    setRoombool(false) //back to main
    newgame() //reset values
  }

  function nextround(){ //go to next round and also inform everyone else, also get new deck
    socket.emit("next_round", room) //send room number
  }

  const gethistorylog = (played, clear) => {
    if (played.length === 0){ //made pass, no cards
      setHistorylog(oldarray => [...oldarray, {'player': (yourturn ? "playerturnhist" : "opponentturnhist"), 'card' : played, 'special': 'passed'}])
    }
    else if (played.length === 1 && played[0] === "S3"){ //is a 3 of spades
      if (clear){ //board is cleared from 3 of spades
        setHistorylog(oldarray => [...oldarray, {'player': (yourturn ? "playerturnhist" : "opponentturnhist"), 'card' : played, 'special': 'passed'}])
      }
      else{
        setHistorylog(oldarray => [...oldarray, {'player': (yourturn ? "playerturnhist" : "opponentturnhist"), 'card' : played}])
      }
    }
    else{
      setHistorylog(oldarray => [...oldarray, {'player': (yourturn ? "playerturnhist" : "opponentturnhist"), 'card' : played}]) //card can also just be winner loll
    }
    
    if (played.length === 4) //made a revolution, this is its seperate log
    {
      if(!revolution){ //reg revolution
        setHistorylog(oldarray => [...oldarray, {'player': (yourturn ? "playerturnhist" : "opponentturnhist"), 'card' : played, 'special': 'revolution'}]) //callback function?
      }
      else{ //is a counter revolution
        setHistorylog(oldarray => [...oldarray, {'player': (yourturn ? "playerturnhist" : "opponentturnhist"), 'card' : played, 'special': 'counterrevolution'}]) //callback function?
      }
    }
  }

  const joinRoom = () => {
    if (room !== ""){
      socket.emit("join_room", room);
    }
  }

  const status = () => { //the status, is an arrow function???
    if (winner === true){
      if (yourturn){
        return "The opponent won!"
      }
      else{
        return "You won!"
      }
    }
    else if (revolution === true){
      return "Revolution!"
    }
    else{
      return "Game Start!"
    }
  }

  if (inroom === false){
    return(
      <>
        <JoinPanel setRoom = {setRoom} joinRoom = {joinRoom}/>
      </>
    )
  }
  else if (inwaitroom === true){
    return(
      <>
        <div id='greypanel'>
          <h1 style={{'color': 'white'}}>Room Code: {room}</h1>
          <h2 style={{'color': 'white'}}>Waiting for Player 2...</h2>
        </div>
      </>
    )
  }
  else{
    return (
      <>
        <h1 className= {yourturn ? "playerturn" : "opponentturn"} >{winner ? null : (yourturn ? "Your Turn": "Opponent Turn")}</h1>
        <h1>Opponent: {opponentnum} Cards Left</h1>
          <OpponentArea decknum = {opponentnum}/>
        <h1 style = {winner ? null : (revolution ? {'color' : 'red'} : {})}>{status()}</h1>
        <HistoryLog historylog = {historylog}/>
        <PlayArea playcards = {playareacards}/>
        <h1>Player: {hand.length} Cards Left</h1>
          <CardArea 
            Quit = {quitgame}
            Restart = {nextround}
            currentcards = {currentcards} 
            setcurrentcards = {setcurrentcards}
            currentcardnum = {currentcardnum}
            setcurrentcardnum = {setcurrentcardnum}
            Hand = {hand}
            setHand = {setHand}
            Turn = {yourturn}
            Disable = {winner}
            Onplayclick = {onplaycards} 
            PlayAreaCards={playareacards} 
            Rev = {revolution} 
            OnRevolution = {setrevolution}/>
        </>
    );
  }
}

export default Board

/////////////////////
